import React from "react";
import { useApp } from "../context/AppContext";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_timeshare-calculator/artifacts/7gkgelre_LOGOTIPO%20ALTERNATIVO%20blanco.png";

const Footer = () => {
  const { t } = useApp();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-white/5 bg-black py-10 text-white" data-testid="footer">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-6 px-6 sm:flex-row sm:px-8">
        <div className="flex items-center gap-3">
          <img src={LOGO_URL} alt="Ourigen" className="h-10 w-10 object-contain" />
          <span className="font-display tracking-[0.4em] text-white">OURIGEN</span>
        </div>
        <p className="text-xs uppercase tracking-luxury text-white/50">
          © {year} OURIGEN. {t("footer_rights")}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
